import * as React from 'react';
import styled from 'styled-components';
import {
  compose,
  space,
  color,
  layout,
  typography,
  SpaceProps,
  ColorProps,
  LayoutProps,
  TypographyProps,
} from 'styled-system';
import { nanoid } from 'nanoid';
export type IconProps = SpaceProps & ColorProps & LayoutProps & TypographyProps;
const SvgComponent = React.forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement> & {
    title?: any;
  }
>(({ title, ...props }, svgRef) => {
  const [titleId] = React.useState(() => (title ? nanoid() : undefined));
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      ref={svgRef}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="currentColor"
        d="M12.718 3.392a1.5 1.5 0 00-1.436 0L2.61 8.122a1 1 0 000 1.756L5 11.18v5.407a1 1 0 00.521.877l5.76 3.144a1.5 1.5 0 001.438 0l5.76-3.144a1 1 0 00.521-.877V11.18l2-1.09V16a1 1 0 102 0V9.594a1 1 0 00-.521-.878l-9.76-5.324zM18.82 9L12 12.72 5.18 9l6.341-3.459a1 1 0 01.958 0L18.82 9zM17 15.99l-4.52 2.468a1 1 0 01-.96 0L7 15.99v-3.72l4.281 2.338a1.5 1.5 0 001.438 0L17 12.27v3.72z"
      />
    </svg>
  );
});
export const IconSystemV2CourseSchoolGraduateHatStudy = styled(SvgComponent)<IconProps>(
  {
    flex: 'none',
    verticalAlign: 'middle',
  },
  compose(space, color, layout, typography)
);
